var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"feather-icon select-none relative switch-publish",attrs:{"title":"Published / Un-Published"}},[_c('vs-switch',{model:{value:(_vm.params.data.IsPublished),callback:function ($$v) {_vm.$set(_vm.params.data, "IsPublished", $$v)},expression:"params.data.IsPublished"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }